import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_TRACKING_ID = import.meta.env.VITE_GA_TRACKING_ID;

let isGaInitialized = false;

// Function to initialize Google Analytics script
export const initializeGA = () => {
  if (isGaInitialized || !GA_TRACKING_ID || typeof window.gtag !== 'undefined') {
    return;
  }

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function(...args: any[]) {
    window.dataLayer?.push(args);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA_TRACKING_ID);

  isGaInitialized = true;
  console.log('Google Analytics initialized.');
};

// Hook to track page views
export const usePageTracking = (consentGiven: boolean) => {
  const location = useLocation();

  useEffect(() => {
    if (!consentGiven || !isGaInitialized) return;

    if (window.gtag) {
      window.gtag('config', GA_TRACKING_ID, {
        page_path: location.pathname + location.search,
      });
      console.log(`GA PageView tracked for: ${location.pathname + location.search}`);
    }
  }, [location, consentGiven]);
};
